import React, { useState } from 'react';
import { Document } from '../../Models/Document';
import { useNavigate, useLocation } from "react-router-dom";
import {
  Typography,
  Card,
  CardContent,
  CardActionArea,
  Box,
  Button,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import { Star, StarBorder } from '@mui/icons-material';
import { useAPIContext } from '../../Context/APIContext';

const useStyles = makeStyles({
  card: {
    borderRadius: '5px !important',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    transition: 'box-shadow 0.2s ease !important',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    width: '100%',
    backfaceVisibility: 'hidden', // Add this line
    '&:hover': {
      boxShadow: '0 6px 12px rgba(0, 0, 0, 0.3)',
    },
  },
  media: {
    height: 140,
  },
  content: {
    textAlign: 'center', // Center-align the text
  },
  documentName: {
    height: '4rem', // Set fixed height
    overflowY: 'hidden', // Hide overflowing text
    //fontWeight: 'bold', // Bold text for Document name
    color: '#333', // Custom text color
    textAlign: 'left'
  },
  dateAdded: {
    textAlign: 'left',
    overflowY: 'hidden', // Hide overflowing text
    display: 'flex',
     alignItems: 'center'
  },
  infoSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '8px',
  },
});

interface DocumentCardProps {
  document: Document;
  saved: boolean;
  goBackUrl: string;
}

export default function DocumentCard({ document,saved,goBackUrl }: DocumentCardProps) {
  const navigate = useNavigate();
  const classes = useStyles();
  const [isSaved, setIsSaved] = useState(saved);
  const { state } = useLocation();
  const { apiFetch } = useAPIContext();

  const NavigateToDocument = (document: Document) => {
    navigate(`/document/${document.id}`, { state: { ...state, ViewDocumentGoBackUrl: goBackUrl } });
  };

  const SaveStream = async (event: React.MouseEvent) => {
    event.stopPropagation();
    const response = await apiFetch<number>(`Users/SavedDocuments`, 'POST', document.id);
    if (response && response > 0) {
      setIsSaved(true);
    }
  };

  const UnfavouriteStream = async (event: React.MouseEvent) => {
    event.stopPropagation();
    const response = await apiFetch<number>(`Users/SavedDocuments`, 'DELETE', document.id);
    if (response && response > 0) {
      setIsSaved(false);
    }
  };

  return (
    <>
      <Card className={classes.card} key={document.id}>
        <CardActionArea onClick={() => NavigateToDocument(document)}>
          <CardContent className={classes.content}>
            <Typography gutterBottom variant="body2" component="div" className={classes.documentName}>
              {document.title}
            </Typography>
              <div className={classes.infoSection}>
                <Box 
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: '#f0f4f0', // Light background to make points stand out
                    borderRadius: '5px',         // Rounded corners
                    padding: '4px 4px',         // Padding inside the box
                    color: '#66bb6a',            // Use the green color for the points
                    fontWeight: 'bold',          // Make the text bold
                    //boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' // Subtle shadow
                    
                  }}
                >
                  <ElectricBoltIcon sx={{ color: '#66bb6a', marginRight: '4px' }} />
                  {document?.points}
                </Box>
              <Button
                size="small"
                startIcon={isSaved ? <Star /> : <StarBorder />}
                onClick={isSaved ? UnfavouriteStream : SaveStream}
              >
                {isSaved ? 'Saved' : 'Save'}
              </Button>
            </div>

          </CardContent>
        </CardActionArea>
      </Card>

    </>
  );
}
